import React, { useEffect, useRef } from "react";
import TimerPicture from "../../assets/images/iphone-mockups/Features/SVYMJ1I2.png";
import SessionsPicture from "../../assets/images/iphone-mockups/Features/7NJVJ8TQ.png";
import AnalyticsPicture from "../../assets/images/iphone-mockups/Features/751TEQPR.png";
import "./Features.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFireAlt,
  faCoffee,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";
import PhoneImage from "../PhoneImage/PhoneImage";

const Features = () => {
  const featureRefs = useRef([]);

  useEffect(() => {
    let index = 0;
    const demoImage = document.getElementById("phoneImage");

    const interval = setInterval(() => {
      // Remove selected from all features
      featureRefs.current.forEach((f) => f.classList.remove("selected"));

      // Add selected to current
      const currentFeature = featureRefs.current[index];
      if (currentFeature) {
        currentFeature.classList.add("selected");
        const newImage = currentFeature.getAttribute("data-image");
        demoImage.src = newImage;
      }

      // Increment index
      index = (index + 1) % featureRefs.current.length;
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="features-section">
        <PhoneImage id="phoneImage" src={TimerPicture} />
        <h2 className="title">Build a Better Coffee Routine</h2>
        <div className="features-list">
          <div
            className="feature selected"
            data-image={TimerPicture}
            ref={(el) => (featureRefs.current[0] = el)}
          >
            <i>
              <FontAwesomeIcon icon={faCoffee} />
            </i>
            <p className="feature-description">
              Track every coffee session with a simple timer and keep your daily
              routine organized in one place.
            </p>
          </div>

          <div
            className="feature"
            data-image={SessionsPicture}
            ref={(el) => (featureRefs.current[1] = el)}
          >
            <i>
              <FontAwesomeIcon icon={faFireAlt} />
            </i>
            <p className="feature-description">
              <p className="feature-description">
                Take photos of your coffee during each session and build a
                visual timeline of your focus moments.
              </p>
            </p>
          </div>

          <div
            className="feature"
            data-image={AnalyticsPicture}
            ref={(el) => (featureRefs.current[2] = el)}
          >
            <i>
              <FontAwesomeIcon icon={faChartLine} />
            </i>
            <p className="feature-description">
              <p className="feature-description">
                View analytics to understand your focus patterns and see your
                progress over time.
              </p>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
